import { DateTime } from 'luxon';
import { Opaque } from 'type-fest';

export type GqlIsoDate = Opaque<string, 'GqlIsoDate'>;

export function formatGqlIsoDate(value: Date): GqlIsoDate;
export function formatGqlIsoDate(value?: Date | null): GqlIsoDate | undefined;
export function formatGqlIsoDate(value?: Date | null): GqlIsoDate | undefined {
  if (value == null) return;

  const dt = DateTime.fromJSDate(value);
  if (!dt.isValid) throw new Error('formatGqlIsoDate received an invalid Date');

  return dt.toFormat('yyyy-MM-dd') as GqlIsoDate;
}

export function parseGqlIsoDate(value: Date | GqlIsoDate | string): Date;
export function parseGqlIsoDate(value?: GqlIsoDate | null): Date | undefined;
export function parseGqlIsoDate(value?: Date | GqlIsoDate | string | null): Date | undefined {
  if (!value) {
    return undefined;
  }
  if (value instanceof Date) {
    return value;
  }

  const parsedDate = DateTime.fromFormat(value, 'yyyy-MM-dd');

  if (!parsedDate.isValid) {
    throw new Error('Invalid Date');
  }

  return parsedDate.toJSDate();
}
